











import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { SurveyElement, Question, PanelModel, doKey2ClickUp } from "survey-core";

@Component
export class ElementHeader extends Vue {
  @Prop() element: Question | PanelModel;
  @Prop() css: any;

  clickTitleFunction(e: any) {
    if(typeof (<any>this.element).clickTitleFunction === "function") {
      (<any>this.element).clickTitleFunction(e);
    }
  }

  get titleStyle() {
    const headerStyle: any = { width: undefined };
    if("titleWidth" in this.element) {
      headerStyle.width = this.element.titleWidth;
    }
    return headerStyle;
  }
}
Vue.component("survey-element-header", ElementHeader);
export default ElementHeader;
